import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Users, MessageCircle, Star, User } from "lucide-react";

const BottomNav = () => {
  const location = useLocation();

  const navItems = [
    { icon: Home, label: "Home", path: "/dashboard", color: "purple" },
    { icon: Users, label: "Discover", path: "/discover", color: "pink" },
    { icon: Star, label: "Niamh", path: "/niamhs-corner", color: "amber" },
    { icon: MessageCircle, label: "Messages", path: "/messages", color: "teal" },
    { icon: User, label: "Profile", path: "/profile", color: "rose" },
  ];

  const getColors = (color, isActive) => {
    const colors = {
      purple: isActive ? 'text-purple-600 bg-purple-100' : 'text-slate-400 hover:text-purple-500 hover:bg-purple-50',
      pink: isActive ? 'text-pink-600 bg-pink-100' : 'text-slate-400 hover:text-pink-500 hover:bg-pink-50',
      amber: isActive ? 'text-amber-600 bg-amber-100' : 'text-slate-400 hover:text-amber-500 hover:bg-amber-50',
      teal: isActive ? 'text-teal-600 bg-teal-100' : 'text-slate-400 hover:text-teal-500 hover:bg-teal-50',
      rose: isActive ? 'text-rose-600 bg-rose-100' : 'text-slate-400 hover:text-rose-500 hover:bg-rose-50',
    };
    return colors[color] || colors.purple;
  };

  return (
    <nav className="bottom-nav bg-white/90 backdrop-blur-lg border-t border-purple-100 shadow-lg" data-testid="bottom-nav">
      <div className="max-w-lg mx-auto px-2">
        <div className="flex items-center justify-around py-1">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path || 
              (item.path === "/messages" && location.pathname.startsWith("/messages"));
            
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`flex flex-col items-center py-2 px-3 rounded-2xl transition-all ${getColors(item.color, isActive)}`}
                data-testid={`nav-${item.label.toLowerCase()}`}
              >
                <item.icon 
                  className={`w-6 h-6 ${isActive ? 'stroke-[2.5px]' : ''}`} 
                  fill={item.label === "Niamh" && isActive ? "currentColor" : "none"}
                />
                <span className={`text-xs mt-1 ${isActive ? 'font-semibold' : 'font-medium'}`}>{item.label}</span>
              </Link>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default BottomNav;